import {
  AbilityBuilder,
  CreateAbility,
  createMongoAbility,
} from '@casl/ability'

import { AppAbility, UserAbilityDetails, permissions } from '@/app/permissions'

const createAppAbility = createMongoAbility as CreateAbility<AppAbility>

export default function defineAbilityForUser(user: UserAbilityDetails | null) {
  const abilityBuilder = new AbilityBuilder<AppAbility>(createAppAbility)

  if (user) {
    const hasPermissions = typeof permissions[user.role] === 'function'

    if (!hasPermissions) {
      throw new Error('Invalid role')
    }

    permissions[user.role](user, abilityBuilder)
  }

  const ability = abilityBuilder.build({
    detectSubjectType(subject) {
      return subject.__typename
    },
  })

  ability.can = ability.can.bind(ability)
  ability.cannot = ability.cannot.bind(ability)

  return ability
}
